export enum ProductActions {
  GET_PRODUCT_DATA = 'product/GET_PRODUCT_DATA',
  GET_PRODUCT_DATA_DISPLAY = 'product/GET_PRODUCT_DATA_DISPLAY',
  GET_PRODUCT_LIST = 'product/GET_PRODUCT_LIST',
  SET_DEFAULT_SELECTED_REGION = 'product/SET_DEFAULT_SELECTED_REGION',
  SET_PRODUCT_DATA = 'product/SET_PRODUCT_DATA',
}
